
import getImageSources from './image-sources';
import { builderDispatch, WebUI, PrismUI } from '../_utils/ui';

(function () {
  if (typeof s_omni !== 'object') {
    return;
  }

  let old_omni = {};

  const omni = {
    adid: s_omni.getQueryParam('adid'),
    fbref: s_omni.getQueryParam('fb_ref'),
    sourceid: s_omni.getQueryParam('sourceid'),
    povid: s_omni.getQueryParam('povid'),
    findingMethod: s_omni.getQueryParam('findingMethod'),
    getCampaignId() {
      if (this.adid) {
        return this.adid;
      }
      if (this.fbref) {
        return this.fbref.split('_')[1];
      }
      if (this.sourceid) {
        return this.sourceid;
      } return '';
    },
  }; s_omni.campaign = omni.getCampaignId(); s_omni.channel = window.location.hostname;
  // Create IE + others compatible event handler
  const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
  const eventer = window[eventMethod];
  const messageEvent = (eventMethod === 'attachEvent') ? 'onmessage' : 'message';

  //* ***********************************************************************
  // Event Tracking Code

  function setPhotoUpload() {
    old_omni = $.extend({}, s_omni); // Clone old vars

    s_omni.pageName = 'Upload Photos';
    s_omni.prop1 = 'Photo Upload';
    s_omni.prop2 = 'Upload Photos';
    s_omni.prop3 = '';
    s_omni.prop4 = '';
    s_omni.prop5 = '';
    s_omni.events = 'event106';
  }


  function unsetPhotoUpload() {
    s_omni.pageName = old_omni.pageName;
    s_omni.prop1 = old_omni.prop1;
    s_omni.prop2 = old_omni.prop2;
    s_omni.prop3 = old_omni.prop3;
    s_omni.prop4 = old_omni.prop4;
    s_omni.events = old_omni.events;
  }

  const photoStrings = {};
  const imageSources = getImageSources();
  if (imageSources) {
    imageSources.forEach((source) => {
      photoStrings[source.service] = source.title;
    });
  }

  function getServiceName(service) {
    if (photoStrings.hasOwnProperty(service)) {
      return photoStrings[service];
    }
    return 'Unknown';
  }

  function getEventName(event, eventType) {
    if (WebUI && eventType && eventType.hasOwnProperty(event)) {
      return eventType[event];
    }
    return 'Unknown';
  }

  //* ***********************************************************************
  // Click Event Listeners

  const clickDispatchToken = builderDispatch.register((payload) => {
    try {
      switch (payload.type) {
        //* ********************************************************************
        // Photo Uploader Cases
        case WebUI.PROMPT_LOGIN:
          setPhotoUpload();
          omniLinkClick('o', getEventName('pleaselogin', WebUI.PhotoEvents));
          unsetPhotoUpload();
          break;

        case WebUI.PHOTO_EVENT_UPLOAD:
          setPhotoUpload();
          omniLinkClick('o', getEventName(payload.uploadEvent, WebUI.PhotoEvents));
          unsetPhotoUpload();
          break;

        case WebUI.PHOTO_SERVICE_SELECTED:
          setPhotoUpload();
          omniLinkClick('o', `Toggle: ${getServiceName(payload.service)}`);
          unsetPhotoUpload();
          break;

        // Service Connected
        case WebUI.PHOTO_SERVICE_CONNECTED:
          setPhotoUpload();
          omniLinkClick('o', `Connect: ${getServiceName(payload.service)}`);
          unsetPhotoUpload();
          break;

        // Prints Builder Cases
        case PrismUI.ADD_PHOTOS:
          omniLinkClick('o', 'Add Photos');
          break;

        case WebUI.PHOTO_EVENT_CHANGE_CLICKED:
        case WebUI.PHOTO_EVENT_ADVANCED_EDIT:
        case WebUI.PHOTO_EVENT_RESIZE_ALL:
        case WebUI.PHOTO_EVENT_CHANGE_QUANTITY:
        case WebUI.PHOTO_EVENT_PREVIEW:
        case WebUI.PHOTO_EVENT_EDIT:
        case WebUI.PHOTO_EVENT_ADD_TO_CART:
        case WebUI.PHOTO_EVENT_REMOVE_PRINTS_MODAL:
        case WebUI.PHOTO_EVENT_REMOVE_PRINTS_CONFIRM:
        case WebUI.PHOTO_EVENT_REMOVE_PRINTS_CANCEL:

          omniLinkClick('o', getEventName(payload.type, WebUI.PhotoEventStrings));
          break;

        case PrismUI.EVENT_CUSTOMIZE_COVER:
        case PrismUI.EVENT_CUSTOMIZE_DESIGNS:
        case PrismUI.EVENT_CUSTOMIZE_LAYOUTS:
        case PrismUI.EVENT_CUSTOMIZE_ENVELOPE:
        case PrismUI.EVENT_MORE_DESIGNS:
        case PrismUI.EVENT_TEMPLATES:
        case PrismUI.EVENT_COLORS:
        case PrismUI.EVENT_ADD_TO_CART:
        case PrismUI.EVENT_SAVE_PROJECT:
        case PrismUI.EVENT_EDIT_PROJECT_NAME:
        case PrismUI.EVENT_CHANGE:
        case PrismUI.EVENT_AUTO_FILL:
        case PrismUI.EVENT_ADD_PHOTOS:
        case PrismUI.EVENT_HIDE_PHOTOS:
        case PrismUI.EVENT_HIDE_USED:
        case PrismUI.EVENT_SHOW_PHOTOS:
        case PrismUI.EVENT_PAGES:
        case PrismUI.EVENT_PREVIEW:
        case PrismUI.EVENT_EDIT:

          omniLinkClick('o', getEventName(payload.type, PrismUI.EventStrings));
          break;
      }
    } catch (e) {
      window.console && window.console.warn && window.console.warn(e);
    }
  });

  //* ***********************************************************************
  // Connect Event Listeners

  eventer(messageEvent, (e) => {
    const msg = e.data;

    if (typeof msg !== 'string') {
      return;
    }
    if (!msg.match('Attempt to connect to')) {
      return;
    }
    const parts = msg.split('///');

    if (parts[1]) {
      // Decoupled due to odd cross domain issues see sporadically
      setTimeout(() => {
        builderDispatch.dispatch({ type: WebUI.PHOTO_SERVICE_CONNECTED, service: parts[1] });
      }, 100);
    }
  }, false);


  //* ***********************************************************************
  // Omni Dispatcher

  function omniLinkClick(linkType, omniLinkName) {
    const s_linkTrackVarsTemp = s_omni.linkTrackVars;
    const s_linkTrackEventsTemp = s_omni.linkTrackEvents;
    s_omni.linkTrackVars = 'prop54';
    s_omni.linkTrackEvents = 'None';
    s_omni.prop54 = `${s_omni.prop2} | ${omniLinkName}`;
    s_omni.tl(omni, linkType, 'Link click');
    // Clean Up
    s_omni.linkTrackVars = s_linkTrackVarsTemp;
    s_omni.linkTrackEvents = s_linkTrackEventsTemp;
    s_omni.prop54 = '';
  }

  //* ***********************************************************************
  // Clean Up
  window.addEventListener('unload', () => {
    builderDispatch.unregister(clickDispatchToken); // Clean up on exit
  });
}());
